import React, { useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import Slider from "react-slick";
import moment from "moment";
import { useHistory } from "react-router-dom";

import Loader from "../../components/Loading/loading";
import useMediaQuery from "../../Hooks/useMediaQuery";
import LinkButton from "../../utils/LinkButton";
import Carousel from "../../components/Slick/CarouselCandidatoConecta";
import ico_group from "../../static/images/ico-group.svg";
import useOnceEffect from "../../Hooks/useOnceEffect";

import "../../static/css/conectStyle.css";
import "../../static/css/custom.css";
import useDebounce from "../../Hooks/useDebounce";
import { SlideCursos } from "../../components/Slick/CarouselCursosRecomendados";
import { MiRed } from "../Company/Conecta";
import defaultLogo from "../../static/images/472.png";
import cursosimg from "../../static/images/cursos_default.png";

export function NextArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="carousel-control-next"
      type="button"
      data-bs-target={"#carousel"}
      data-bs-slide="next"
      onClick={onClick}
    ></button>
  );
}

export function PrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="carousel-control-prev"
      type="button"
      data-bs-target={"#carousel"}
      data-bs-slide="prev"
      onClick={onClick}
    ></button>
  );
}

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  centerMode: false,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 912,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,

        infinite: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        infinite: true,
      },
    },
  ],
};

const INITIAL = {
  filter: [],
  data: [],
};

const Conecta = () => {
  const [loading, setLoading] = useState(true);
  const [listRegisterUser, setlistRegisterUser] = useState([]);
  const [contactosList, setcontactosList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [index] = useState(0);
  const matchedMobile = useMediaQuery("(max-width: 927px)");
  const isMobile = useMediaQuery("(max-width: 927px)");

  const [listEvents, setlistVents] = useState(INITIAL);
  const [empresasList, setempresasList] = useState(INITIAL);
  const [centrosList, setcentrosList] = useState(INITIAL);
  const [ROLE, setRole] = useState("");
  const USER_BASE_URL = useRef("");
  const history = useHistory();

  const debounceSearch = useDebounce(
    (search = "", key = "", setEstado = () => {}) => {
      setEstado((_old) => {
        if (search === "") {
          return {
            ..._old,
            filter: _old.data,
          };
        }

        let _new = _old.data.filter((elm) => {
          return elm[key].toLowerCase().includes(search.toLowerCase());
        });

        return {
          ..._old,
          filter: _new,
        };
      });
    }
  );

  function GetEvents() {
    axios.get("/exclusive-events-currently").then((result) => {
      setlistVents({
        filter: result.data,
        data: result.data,
      });
    });
  }

  function GetUserList(index, qty) {
    axios
      .get("access/list-applicants", {
        params: {
          page: index,
          paginate: qty,
        },
      })
      .then((result) => {
        let arr = result.data.content;
        setlistRegisterUser([...arr, listRegisterUser]);
        setLoading(false);
      });
  }

  function GetContactoList(index, qty) {
    axios
      .get("access/list-applicants", {
        params: {
          page: index,
          paginate: qty,
        },
      })
      .then((result) => {
        let arr = result.data.content;
        // setlistRegisterUser([...arr, listRegisterUser]);
        setcontactosList([...arr, contactosList]);
        setLoading(false);
      });
  }

  function setLinkCentroFormacion(item) {
    let rol = localStorage.getItem("rol");

    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/PerfilEmpresa",
          state: { profileId: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Empresa",
          state: { profileId: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Empresa",
          state: { profileId: item },
        });
        break;

      default:
        break;
    }
  }

  function setLinkAliados(item) {
    let rol = localStorage.getItem("rol");

    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/PerfilEmpresa",
          state: { profileId: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/Empresa",
          state: { profileId: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Empresa",
          state: { profileId: item },
        });
        break;

      default:
        break;
    }
  }

  function getEmpresas() {
    axios.get("access/list-company").then((result) => {
      if (result.status === 200) {
        setempresasList({
          filter: result.data,
          data: result.data,
        });
      } else if (result.status === 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
  }

  function getCentros() {
    axios.get("formacion/list").then((result) => {
      if (result.status === 200) {
        setcentrosList({
          filter: result.data,
          data: result.data,
        });
      } else if (result.status === 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
  }

  function baseUrl() {
    const role = localStorage.getItem("rol");
    setRole(role);
    switch (role) {
      case "applicant":
        USER_BASE_URL.current = "user";
        break;
      case "company":
        USER_BASE_URL.current = "company";
        break;
      case "institute":
        USER_BASE_URL.current = "CentroFormacion";
        break;

      default:
        break;
    }
  }

  useOnceEffect(() => {
    GetUserList(index, 3);
    GetContactoList();
    getEmpresas();
    getCentros();
    GetEvents();
    baseUrl();

    axios.get("groups/random").then((result) => {
      setGroups(result.data);
    });
  });

  return (
    <div className="vacantes perfil-empresa usuario">
      {loading ? <Loader type="full"></Loader> : ""}
      <div id="conect">
        <div className="container mt-3">
          <div className="row vacancy__content">
            <div className="col-12 col-md-4 col-lg-4">
              {ROLE === "institute" ? (
                <MiRed path={USER_BASE_URL.current} />
              ) : (
                <div className="vacancy__sidebar">
                  <div className="bordered-box">
                    <div className="bordered-box__header mb-4">
                      <div
                        className="bordered-box__header-title"
                        style={{ textAlign: "center" }}
                      >
                        Mi Red
                      </div>
                    </div>
                    <div className="d-flex flex-row pb-1 pe-2 ps-2">
                      <div
                        className="col-1 col-md-1"
                        onClick={() =>
                          document
                            .getElementById("groups_carousel")
                            ?.scrollIntoView()
                        }
                      >
                        <img src={ico_group} alt="Grupos" type="button"></img>
                      </div>
                      <div className="col-10col-md-6 pb-1 pe-1 ps-1">
                        <span className="card-text" type="button">
                          Grupos
                        </span>
                      </div>
                    </div>
                    <hr></hr>

                    <div className="row pb-1 pe-2 ps-2">
                      <div
                        className="col-12 col-md-6"
                        onClick={() =>
                          document
                            .getElementById("events_carousel")
                            ?.scrollIntoView()
                        }
                      >
                        <i class="fas fa-calendar-check" type="button"></i>

                        <span className="card-text" type="button">
                          Eventos
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 col-md-8">
              <div className="vacancy__description bordered-box">
                <div>
                  <Carousel
                    id="Vacante"
                    qty={matchedMobile ? 1 : 4}
                    titulo="Comunidad Krezco"
                  ></Carousel>
                </div>

                <div className="mb-5 mt-5 ps-2 pe-2">
                  <hr></hr>
                </div>

                <div className="autoplay">
                  <Carousel
                    id="Vacantes"
                    qty={matchedMobile ? 1 : 4}
                    titulo="Sugerencias para tí"
                  ></Carousel>
                </div>
              </div>

              <div className="vacancy__description bordered-box">
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Nuestros Aliados</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search "></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setempresasList)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {empresasList.filter.map((item) => (
                      <div key={item.companyId} className="conect-card">
                        <div className="card">
                          <div className="mt-4 box-imgCat2">
                            <img
                              src={
                                item.profileImagePath !== null
                                  ? item.profileImagePath
                                  : defaultLogo
                              }
                              alt=""
                              onClick={() => setLinkAliados(item.companyId)}
                            ></img>
                          </div>
                          <div className="card-body">
                            <h5 className="mb-3 card-title">{item.name}</h5>
                            <div className="mt-4 mb-4 badges2"></div>

                            <hr></hr>

                            <button
                              className="mt-4 mb-2 btn btn-info"
                              onClick={() => setLinkAliados(item.companyId)}
                            >
                              Ver Perfil
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>

              <div
                className="vacancy__description bordered-box"
                id="groups_carousel"
              >
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">
                        Dale un vistazo a los grupos{" "}
                      </span>
                    </div>
                  </div>

                  <div className="autoplay">
                    <Slider {...settings}>
                      {groups.map((item, i) => (
                        <div key={item.id} className="conect-card">
                          <div className="card">
                            <div className="mt-5 box-imgCat2 default-cover">
                              <img
                                src={item.image ? item.image : cursosimg}
                                alt={"group_" + i}
                              ></img>
                            </div>
                            <div className="card-body">
                              <h5 className="mb-3 card-title">{item.name}</h5>
                              <div className="mt-4 mb-4 badges2"></div>
                              <hr></hr>

                              <button
                                className="mt-4 mb-2 btn btn-info"
                                onClick={() =>
                                  history.push(
                                    `/${USER_BASE_URL.current}/group-connect/${item.id}`
                                  )
                                }
                              >
                                Ver Grupo
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>

              {localStorage.getItem("rol") === "applicant" && (
                <div
                  className="vacancy__description bordered-box"
                  id="cursos_carousel"
                >
                  <div className="row mt-2 mb-4">
                    <div className="col-12 col-md-6">
                      <div className="p-2 bordered-box__header-title">
                        <span className="align-middle ">
                          Adquiere nuevas habilidades e impulsa tu conocimiento
                        </span>
                      </div>
                    </div>

                    <SlideCursos id={"slide_cursos"} qty={isMobile ? 1 : 3} />
                  </div>
                </div>
              )}

              <div className="vacancy__description bordered-box">
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6 ">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Centro de Formacion</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search"></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setcentrosList)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {centrosList.filter.map((item, index) => (
                      <div key={item.companyId} className="conect-card">
                        <div className="card">
                          <div className="mt-4 box-imgCat2">
                            <img
                              src={
                                item.profileImagePath !== null
                                  ? item.profileImagePath
                                  : defaultLogo
                              }
                              alt=""
                              onClick={() =>
                                setLinkCentroFormacion(item.companyId)
                              }
                            ></img>
                          </div>
                          <div className="card-body">
                            <h5 className="mb-3 card-title">{item.name}</h5>
                            <div className="mt-4 mb-4 badges2"></div>
                            <hr></hr>

                            {/* <a href="#" className="mt-4 mb-2 btn btn-info">
                              Ver
                            </a> */}
                            <button
                              className="mt-4 mb-2 btn btn-info"
                              onClick={() =>
                                setLinkCentroFormacion(item.companyId)
                              }
                            >
                              Ver Perfil
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>

              <div
                className="events vacancy__description bordered-box"
                id="events_carousel"
              >
                <div className="row mt-2 mb-4">
                  <div className="col-12 col-md-6">
                    <div className="p-2 bordered-box__header-title">
                      <span className="align-middle ">Próximos Eventos</span>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 text-end">
                    <div className="search">
                      <i className="fas fa-search"></i>
                      <input
                        type="text"
                        placeholder="Buscar"
                        onChange={({ target }) =>
                          debounceSearch(target.value, "name", setlistVents)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="autoplay">
                  <Slider {...settings}>
                    {listEvents.filter.map((item) => {
                      return (
                        <div className="conect-card">
                          <div className="card">
                            <div className="box-imgCat3 default-cover-evento">
                              <img src={item.image} alt=""></img>
                            </div>
                            <div className="card-body">
                              <h5 className="mb-3 card-title">{item.name}</h5>
                              <div className="mt-4 mb-4 badges3">
                                <h6>
                                  Fecha:{" "}
                                  <span>
                                    {moment(item.startDate).calendar()}
                                  </span>
                                </h6>
                                <h6>
                                  Lugar: <span>{item.place}</span>
                                </h6>
                              </div>
                              <hr></hr>

                              <LinkButton
                                to={{
                                  pathname: `/${USER_BASE_URL.current}/DetalleEvento`,
                                  state: item,
                                }}
                                type="button"
                                className="btn btn-info"
                              >
                                Ver
                              </LinkButton>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Conecta;
